import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import CiCompanyTile from "@components/companies/CompanyTile.vue";
import { useInternalTracking } from "@composables/internalTracking";


export default /*#__PURE__*/_defineComponent({
  __name: 'partner-carousel',
  props: {
    companies: null,
    loading: { type: Boolean, default: true }
  },
  emits: ["tracking-click"],
  setup(__props: any, { emit }: { emit: ({ (event: "tracking-click", options: InternalTracking.TrackClickOptions): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { companies: Companies.Tile[], loading: boolean };



const { propagateTrackClick } = useInternalTracking(emit, "News");

const logosSlide1 = ref<Nullable<HTMLDivElement>>(null);
const logosSlide2 = ref<Nullable<HTMLDivElement>>(null);

watch(
  () => logosSlide1.value,
  () => {
    // the partner carousel upon first render has only the width of the current screen, as partners are dynamically
    // added we need to recalculate the width. Additionally the duration of the animation should be constant independent
    // of the count of active partner
    if (!props.loading && logosSlide1.value && logosSlide1.value.childNodes.length > 0) {
      logosSlide1.value.style.width = `${logosSlide1.value.childNodes.length * 176}px`;
      logosSlide1.value.style.animationDuration = `${logosSlide1.value.childNodes.length * 2}s`;
      if (logosSlide2.value) {
        logosSlide2.value.style.width = `${logosSlide1.value.childNodes.length * 176}px`;
        logosSlide2.value.style.animationDuration = `${logosSlide1.value.childNodes.length * 2}s`;
      }
    }
  }
);

return { __sfc: true,props, emit, propagateTrackClick, logosSlide1, logosSlide2, CiCompanyTile }
}

})